<template>
    <div v-if="!loadingPage" class="pb-2">
        <h3 class="mb-2 text-primary mt-50">گزارش سفارشات آنلاین</h3>
        <b-row class="mb-2">
            <b-col md="3" class="mt-25">
                <b-form-group label="شماره فاکتور" label-for="storeOrderNumberId">
                    <b-form-input v-model="parameters.storeOrderNumber" @keyup.enter="orderOnlinePayments" dir="ltr"
                        id="storeOrderNumberId" class="text-center" autocomplete="off" name="storeOrderNumberId"
                        type="number" />
                </b-form-group>
            </b-col>
            <b-col md="3" class="mt-25">
                <b-form-group label="شماره تراکنش بانک" label-for="transactionCodeId">
                    <b-form-input v-model="parameters.transactionCode" @keyup.enter="orderOnlinePayments" dir="ltr"
                        id="transactionCodeId" class="text-center" autocomplete="off" name="transactionCodeId" />
                </b-form-group>
            </b-col>
            <b-col md="3" class="mt-25">
                <b-form-group label="وضعیت پرداخت" label-for="statusId">
                    <v-select v-model="parameters.status" :searchable="false" id="statusId" dir="rtl"
                        :options="paymentStatus" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                        :reduce="(value) => value.id" label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="3" class="mt-md-2 mt-50">
                <b-button variant="info" @click="orderOnlinePayments" :disabled="loading"
                    class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                    <span>جستجو</span>
                    <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                </b-button>
            </b-col>
        </b-row>
        <b-card class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table v-if="orderList.length" responsive :items="orderList" :fields="fields" class="mb-0" striped>
                    <template #cell(status)="data">
                        <b-badge :variant="payment_StatusVariant(data.item.status)" pill>
                            {{ payment_Status(data.item.status) }}
                        </b-badge>
                    </template>
                    <template #cell(payableAmount)="data">
                        {{ data.item.payableAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(cashbackAmount)="data">
                        {{ data.item.cashbackAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(usedWalletAmount)="data">
                        {{ data.item.usedWalletAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(ordersList)="data">
                        <b-spinner v-if="loadingButton[data.index]" variant="info" small></b-spinner>
                        <feather-icon v-else @click="showOrderList(data.item.id, data.index)" icon="ShoppingBagIcon"
                            class="text-info pointer" size="20" />
                    </template>
                    <template #cell(createdAt)="data">
                        <div>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                    2).join(":") }}
                            </span>
                        </div>
                    </template>
                </b-table>
                <div v-else class="text-center pt-5 pb-4">
                    موردی وجود ندارد
                </div>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="orderOnlinePayments" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />


        <!------------------------------- modal show order list ------------------------------->
        <b-modal id="show-order-list" title="جزئیات سفارش" centered :hide-footer="true" title-class="font-weight-bolder"
            size="lg">
            <div>

                <invoiceDetail :orderDetails="orderDetails" />

                <div v-if="certificateId || certificateId == 0">
                    <b-button v-if="paymentStatusOrder == 1" @click="$refs.Printer.printCustomerInvoice()"
                        class="w-100 mb-1" variant="primary">
                        پرینت فاکتور
                    </b-button>
                </div>

            </div>
        </b-modal>

        <div v-if="certificateId || certificateId == 0">
            <Printer ref="Printer" :customerInvoice="orderPrint" :provider="provider"
                @deleteInvoice="$bvModal.hide('show-order-list')" />
        </div>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay, BFormInput, BSpinner, BBadge, BFormGroup } from 'bootstrap-vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';
import Printer from '@/@core/components/printer/index.vue';
import invoiceDetail from '@/@core/components/invoice-detail/index.vue';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Printer,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BSpinner,
        BFormInput,
        BBadge,
        BFormGroup,
        invoiceDetail,
        vSelect
    },
    computed: {
        payment_Status() {
            return (status) => {
                if (status == 0) {
                    return 'در انتظار پرداخت'
                }
                if (status == 1) {
                    return 'پرداخت شده'
                }
                if (status == 2) {
                    return 'پرداخت نشده'
                }
            }
        },
        payment_StatusVariant() {
            return (status) => {
                if (status == 0) {
                    return 'light-warning'
                }
                if (status == 1) {
                    return 'light-success'
                }
                if (status == 2) {
                    return 'light-danger'
                }
            }
        },
    },
    mixins: [accessHandling],
    data() {
        return {
            orderPrint: {},
            provider: {},
            certificateId: null,
            loadingPage: true,
            loading: false,
            orderList: [],
            paymentStatus: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'در انتظار پرداخت' },
                { id: 1, name: 'پرداخت شده' },
                { id: 2, name: 'پرداخت نشده' },
            ],
            fields: [
                {
                    key: 'storeOrderNumber',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'bankTransactionCode',
                    label: 'شماره تراکنش بانک',
                },
                {
                    key: 'usedWalletAmount',
                    label: 'اعتبار استفاده شده (ریال)',
                },
                {
                    key: 'payableAmount',
                    label: 'مبلغ پرداخت شده (ریال)',
                },
                {
                    key: 'cashbackAmount',
                    label: 'اعتبار صادر شده (ریال)',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'ordersList',
                    label: 'جزئیات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                storeOrderNumber: null,
                transactionCode: null,
                status: null,
            },
            storeId: null,
            orderDetails: {},
            urlName: '',
            paymentStatusOrder: null,
            loadingButton: []
        }
    },
    methods: {
        getStoreDetails() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                data.name_Fa ? this.provider.name = data.name_Fa : this.provider.name = data.name_En;
                this.urlName = data.name_En
                this.provider.logo = data.logoImage;
                this.orderOnlinePayments()
            })
        },
        showOrderList(id, index) {
            if (this.accessHandling('employee', 'order_details_view')) {
                this.orderPrint = {}
                this.$set(this.loadingButton, index, true);
                storeService.orderDetails(this.storeId, id).then(({ data }) => {
                    let dataOrder = data
                    this.paymentStatusOrder = dataOrder.payment.status
                    this.orderPrint.storeOrderNumber = data.storeOrderNumber
                    this.orderPrint.dailyOrderNumber = data.dailyOrderNumber
                    this.orderPrint.createdAt = data.createdAt
                    this.orderPrint.urlName = this.urlName
                    this.orderPrint.taxAmount = data.taxAmount
                    this.orderPrint.discountAmount = data.discountAmount
                    this.orderPrint.usedWalletAmount = data.usedWalletAmount
                    this.orderPrint.orderAmount = data.totalAmount
                    this.orderPrint.amountPayable = data.payableAmount
                    data.campaign ? this.orderPrint.campaignDiscountAmount = data.campaign.discountAmount : null
                    this.orderPrint.productDiscountAmount = data.productDiscountAmount
                    if (data.customer) {
                        this.orderPrint.firstName = data.customer.firstName
                        this.orderPrint.lastName = data.customer.lastName
                        this.orderPrint.phoneNumber = data.customer.phoneNumber
                    }
                    this.orderPrint.type = data.type
                    if (data.type == 1) {
                        this.orderPrint.address = data.address
                    }
                    this.orderPrint.items = []
                    if (dataOrder.items.length) {
                        dataOrder.items.forEach((obj, index) => {
                            this.orderPrint.items[index] = {};
                            this.orderPrint.items[index].name_Fa = obj.productName
                            this.orderPrint.items[index].number = obj.count
                            this.orderPrint.items[index].finalPrice = obj.finalPrice
                        });
                    }
                    this.orderDetails = data
                    this.$set(this.loadingButton, index, false);
                    this.$bvModal.show('show-order-list')
                })

                    .catch((err) => {
                        this.$set(this.loadingButton, index, false);
                    });
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        orderOnlinePayments() {
            this.loading = true
            this.loadingButton = []
            storeService.orderOnlinePayments(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.orderList = data.items
                    if (this.orderList.length) {
                        this.orderList.forEach(obj => {
                            this.loadingButton.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.orderList = data.items
                        if (this.orderList.length) {
                            this.orderList.forEach(obj => {
                                this.loadingButton.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.certificateId = localStorage.getItem("certificateId");
        this.getStoreDetails()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>